<script setup>
import { ref } from 'vue'
import { searchSelect } from '@/libs/utils.js'

import TranslationProvider from '@/provider/translations.js'
import { useFiltersStore } from '@/services/store.js'

const props = defineProps({
  label: String,
  attribute: String,
  pageType: {
    type: String,
    default: 'compiled-poll-list'
  }
})

const filtersStore = useFiltersStore()

const currentSearch = ref('')
const resultsList = ref([])

</script>

<template>

  <label :for="props.attribute" class="form-label">
    {{ props.label }}
  </label>

  <v-select
    :id="props.attribute"
    @search="async (searchQuery, loading) => {
               currentSearch = searchQuery;
               resultsList = await searchSelect(
                  searchQuery,
                  loading,
                  props.attribute,
                )
              }"
    v-model="filtersStore.filters[props.pageType][props.attribute]"
    :options="resultsList"
    :filterable="false"
    @search:blur="() => { resultsList = [] }"
    @search:selected="() => { resultsList = [] }"
    :placeholder="props.label"
    clearable
  >
    <template v-slot:no-options>
          <span v-if="currentSearch.length >= 3">
              {{ TranslationProvider.getTrans('app.no_result_found') }}
          </span>
      <span v-else>
             {{ TranslationProvider.getTrans('app.digita_per_cercare') }}
          </span>
    </template>
  </v-select>

  <small class="form-text">
    {{ TranslationProvider.getTrans('app.select2_min_chars') }}
  </small>
</template>
